import { render, staticRenderFns } from "./ResetPasswordCard.vue?vue&type=template&id=d7c7e03c"
import script from "./ResetPasswordCard.vue?vue&type=script&lang=js"
export * from "./ResetPasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports